import {
  endOfToday,
  isBefore,
  isEqual,
  startOfToday,
  subDays,
  addMonths,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYesterday,
  endOfYesterday,
} from 'date-fns';
import isEmpty from 'lodash-es/isEmpty';

import { periodFromDate } from '@ecp/common/src/utils/dateUtils';

const usePeriod = (fromDateProp, toDateProp, periodProp, defaultFromDate, defaultToDate, defaultPeriod, periods) => {
  const datesProps =
    !fromDateProp && !toDateProp && isEmpty(periodProp)
      ? undefined
      : { from: fromDateProp, to: toDateProp, period: periodProp };

  const defaultFromDateProp = fromDateProp || defaultFromDate;
  const defaultToDateProp = toDateProp || defaultToDate;
  const defaultPeriodProp = !isEmpty(periodProp) ? periodProp : defaultPeriod;

  let fromDate = startOfToday();
  let toDate = endOfToday();
  let period = periods.find(({ value }) => '1-days' === value);

  if (defaultFromDateProp) {
    fromDate = defaultFromDateProp;
    period = { value: null };
    if (defaultToDateProp) {
      toDate = isBefore(fromDate, defaultToDateProp) ? defaultToDateProp : fromDate;
      const { from, to } = handlePeriod(defaultPeriodProp);
      if (isEqual(fromDate, from) && isEqual(toDate, to)) {
        period = defaultPeriodProp;
      }
    } else {
      toDate = isBefore(defaultFromDateProp, toDate) ? toDate : defaultFromDateProp;
    }
  } else if (defaultToDateProp) {
    toDate = defaultToDateProp;
    fromDate = isBefore(fromDate, toDate) ? fromDate : toDate;
    period = { value: null };
  } else if (!isEmpty(defaultPeriodProp)) {
    const { from, to } = handlePeriod(defaultPeriodProp);
    fromDate = from;
    toDate = to;
    period = defaultPeriodProp;
  }
  return { datesProps, from: fromDate, to: toDate, period };
};

export const handlePeriod = (period) => {
  if (!period.value) return false;

  if (period.value === 'all') {
    return { from: undefined, to: undefined, period };
  }

  if (period.value === 'yesterday') {
    return { from: startOfYesterday(), to: endOfYesterday(), period };
  }

  if (period.value === 'curWeeks') {
    return { from: startOfWeek(startOfToday()), to: endOfWeek(endOfToday()), period };
  }

  if (period.value === 'prevWeeks') {
    return { from: startOfWeek(subDays(startOfToday(),7)), to: endOfWeek(subDays(endOfToday(),7)), period };
  }
  

  if (period.value === 'curMonth') {
    return { from: startOfMonth(startOfToday()), to: endOfMonth(endOfToday()), period };
  }

  if (period.value === 'prevMonth') {
    return {
      from: startOfMonth(addMonths(startOfToday(), -1)),
      to: endOfMonth(addMonths(endOfToday(), -1)),
      period,
    };
  }

  const [value, unit] = period.value.split('-');
  const duration = {};
  duration[unit] = Number(value);

  const newToDate = endOfToday();
  const newFromDate = periodFromDate(duration);

  return { from: newFromDate, to: newToDate, period };
};

export default usePeriod;
